import { useState, useEffect } from 'react'
import { Table, Typography } from 'antd'
import { getTreasureAnomaly } from 'src/api/reports'
import { isoToTimestamp } from 'src/utils/timestamp'
const { Title, Text } = Typography

const TreasureAnomaly = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const fetchCheater = async (page, size) => {
    setLoading(true)
    try {
      const res = await getTreasureAnomaly(page - 1, size)
      console.log('getTreasureAnomaly : ', res)
      const mapped = res.data.map((item) => ({
        key: item.userId,
        ...item,
      }))
      setTotalRecords(res.total_items)

      setData(mapped)
    } finally {
      setLoading(false)
    }
  }
  const formatEnumText = (text) => {
    if (!text) return ''

    return text
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  const columns = [
    {
      title: 'User Id',
      dataIndex: 'userId',
    },
    {
      title: 'Game Id',
      dataIndex: 'gameId',
    },
    {
      title: 'Country',
      dataIndex: 'country',
    },
    {
      title: 'Over Thershold Minutes',
      dataIndex: 'overThresholdMinutes',
    },
    {
      title: 'Peak Reward Count',
      dataIndex: 'peakRewardCount',
    },
    {
      title: 'Reward Count',
      dataIndex: 'rewardCount',
    },
    {
      title: 'Window From',
      dataIndex: 'windowFrom',
      render: (text) => {
        return isoToTimestamp(text)
      },
    },
    {
      title: 'Window To',
      dataIndex: 'windowTo',
      render: (text) => {
        return isoToTimestamp(text)
      },
    },
    {
      title: 'Date',
      dataIndex: 'createdAt',
      render: (text) => {
        return isoToTimestamp(text)
      },
    },
  ]

  const handleTableChange = (pagination: any) => {
    setData([])
    setCurrentPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  useEffect(() => {
    fetchCheater(currentPage, pageSize)
  }, [currentPage, pageSize])

  return (
    <div>
      <Title level={4} style={{ color: '#fff' }}>
        Treasure Anomaly
      </Title>

      <Table
        style={{ marginTop: 20 }}
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '25', '50', '100'],
          total: totalRecords,
        }}
        onChange={handleTableChange}
      />
    </div>
  )
}
export default TreasureAnomaly
